module.exports = __webpack_public_path__ + "static/media/Pancreatic-pseudoislet-system-pancreas-diabetest-research.817af5b8.jpg";